var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content != null)?_c('div',{staticClass:"co-copy",class:{ disabled: _vm.disabled, default: _vm.$slots.default },on:{"click":_vm.onCopy}},[_vm._t("default"),(!_vm.$slots.default)?[_c('span',[_vm._v("复制")])]:_vm._e(),_c('span',{ref:"input",staticClass:"input"},[_vm._v(_vm._s(_vm.content))])],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }